// extracted by mini-css-extract-plugin
export var cardLayout = "_1u-1";
export var paginationContainer = "_1u-0";